export default "__VITE_ASSET__xAHHsftP__"